<template>


<b-navbar fixed="top" id="navbar" toggleable="lg">
    <b-navbar-brand active-class="brand-active" to="/">
      <img class="align-middle"  src="../../public/Navbar-Logo-03.png" id="navbar-brand-logo" alt="logo">
    </b-navbar-brand>
    
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
               <b-navbar-nav class="mr-auto">
                 <b-nav-item active-class="nav-active" to="/">Background</b-nav-item>
                 <b-nav-item active-class="nav-active" to="/dataportal">Data Portal</b-nav-item>
               </b-navbar-nav>
    </b-collapse>
  </b-navbar>


</template>



<script>
// import PopUp from './PopUp.vue'

export default {
  name: "NavigationBar"
};
</script>

<style>
#navbar {
  height: 50px;
  vertical-align: middle;
  color: black;
  background-color:white;
  /* box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2); */
  border-bottom:.25px solid #f1f1f1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Helvetica', sans-serif;
  font-style: normal;
  font-size: 14.5px;
}
.nav-link {
  color: black !important;
  border-bottom: none !important;
}
.navbar-brand{
  border-bottom: none !important;
  border-bottom:none;
}
.router-link-exact-active.nav-active {
  font-weight:700 !important;
}
.router-link-exact-active.brand-active{
  border-bottom: none !important;
}

#navbar-brand-logo{
  height:30px;
}
.nav-item {
  font-size: 1em;
  white-space: nowrap;
  margin: 0px;
  background-color: white !important;
}


</style>